// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"35":"8166b734","714":"4fc80d5f"}[chunkId] + ".css";
};